import { removeFieldError } from './removeFieldError.js';

export const validateSchoolName = (form, field, errors) => {
  const wrapperSelector = 'div';
  const parentWrapper = field.closest(wrapperSelector);
  const schoolNameInput = form.querySelector(`input[name="school_name"]`);
  const dataSchoolElement = document.getElementById('schoolName');

  // Daten aus dem versteckten Div laden
  let schoolNames = [];
  if (dataSchoolElement) {
    try {
      schoolNames = JSON.parse(dataSchoolElement.textContent || '[]');
    } catch (error) {
      console.error('Fehler beim Parsen der Schulnamen:', error);
    }
  }

  // Validierungsfunktion für Schulnamen
  const isSchoolNameValid = (value) => schoolNames.indexOf(value) > -1;

  // Validierung ausführen
  if (parentWrapper) {
    if (!schoolNameInput.value.trim()) {
      errors.push({
        field,
        wrapper: parentWrapper,
        wrapperErrorClasses: ['error-item', 'form__item'],
        wrapperSuccessClasses: ['valid-item', 'form__item'],
        message: 'Geben Sie den Namen der Schule ein.',
      });
    } else if (!isSchoolNameValid(schoolNameInput.value)) {
      errors.push({
        field,
        wrapper: parentWrapper,
        wrapperErrorClasses: ['error-item', 'form__item'],
        wrapperSuccessClasses: ['valid-item', 'form__item'],
        message: 'Bitte wählen Sie eine gültige Schule aus der Liste aus.',
      });
    }
  }

  // Event-Listener für Echtzeit-Validierung
  schoolNameInput.addEventListener('input', () => {
    const inputValue = schoolNameInput.value.trim();

    if (isSchoolNameValid(inputValue)) {
      removeFieldError(field, errors, wrapperSelector);
    } else if (inputValue === '') {
      errors.push({
        field,
        wrapper: parentWrapper,
        wrapperErrorClasses: ['error-item', 'form__item'],
        wrapperSuccessClasses: ['valid-item', 'form__item'],
        message: 'Geben Sie den Namen der Schule ein.',
      });
    } else {
      errors.push({
        field,
        wrapper: parentWrapper,
        wrapperErrorClasses: ['error-item', 'form__item'],
        wrapperSuccessClasses: ['valid-item', 'form__item'],
        message: 'Bitte wählen Sie eine gültige Schule aus der Liste aus.',
      });
    }
  });
};
